import React, {useEffect, useState} from "react";
import ContactList from "../../components/contactList";
import NvcmisChat from "../../components/chat/nvcmisChat";
import styles from './chatlayout.module.css';
import {SignalRProvider } from '../../contexts/SignalRContext';
const ChatLayout = () => {
    const [groupId, setGroupId] = useState<{groupId:number, createdUser:string}>({groupId:0,createdUser:''});
  const [groupArr, setGroupArr] = useState<any[]>([]);
  
  const handleReceiveData = (data:number, createdUser:string, groupArr:{userName: string, email:string, 
    userAvatar: string, isGroup: boolean}[]) => {
      setGroupId({groupId:data, createdUser:createdUser}); setGroupArr(groupArr);
  }
  
    return(
      <SignalRProvider>
          <div className={styles.ChatContainer}>
            <ContactList handleChangeGroupId={handleReceiveData} />
            {groupId.groupId!=0?<NvcmisChat groupId={groupId.groupId} createdUser={groupId.createdUser}
            groupArr={groupArr}
            />:null}
        </div>
      </SignalRProvider>
    )
}
export default ChatLayout;